import { viewSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const saveWorkOrderView = {
  name: "saveWorkOrderView" as const,
  input: z.object({ view: viewSchemas["work-orders"] }),
  output: z.object({}),
};
